import { TextInput, Typography, Grid } from '@percent/lemonade'
import styles from './DonationFormPage.module.scss'
import { env } from '@percent/cause-dashboard/env'
import { config } from '@percent/cause-dashboard/config'
import { useAuthState, useCausesPortalAnalytics } from '@percent/cause-dashboard/common/hooks'
import { CopyContentButton } from '@percent/domain/giving'
import { createShortLink } from '@percent/utility'
import { t } from 'i18next'
import { DonationFormEventName } from '@percent/cause-dashboard/common/hooks/useCausesDashboardAnalytics/causeDashboardAnalytics.types'

export const ShareableLinkTab = () => {
  const {
    authState: { organisation, user }
  } = useAuthState()
  const { track } = useCausesPortalAnalytics()

  const handleShareLinkButtonClick = () => {
    track(DonationFormEventName.SHARE_LINK_BUTTON, {
      orgId: organisation?.id,
      accountEmail: user?.email,
      country: organisation?.countryCode
    })
  }

  const getDonationLink = (donationLinkRef: string, organisationId: string): string => {
    const hdgwDomain = env.NX_PUBLIC_HDGW_URL
    return `${hdgwDomain}/links/${donationLinkRef}?organisationId=${organisationId}`
  }

  const getShortenedDonationLink = (donationLinkRef: string, organisationId: string): string => {
    const fullLink = getDonationLink(donationLinkRef, organisationId)
    return createShortLink(fullLink, true) // true includes the path
  }

  return (
    <Grid className={styles.shareableLinkContainer} data-testid="shareable-link-tab">
      <Grid.Col className={styles.gridItem}>
        <Typography className={styles.description} data-testId="shareable-link-description">
          {t('donationForm.shareableLink.description')}
        </Typography>
        <div className={styles.shareLinkContentContainer}>
          <Typography variant="default-bold" color="textSecondary" data-testId="shareable-link-subheading">
            {t('donationForm.shareableLink.subheading')}
          </Typography>
          <div className={styles.shareLinkSection}>
            <TextInput
              name="donationLink"
              data-testId="shareable-link-input"
              value={getShortenedDonationLink(config.ids.donationLink, organisation?.id || '')}
              disabled
              onClick={() => {
                handleShareLinkButtonClick()
              }}
            />
            <CopyContentButton
              variant="primary"
              children={t('donationForm.shareableLink.button')}
              content={getDonationLink(config.ids.donationLink, organisation?.id || '')}
              onClick={() => {
                handleShareLinkButtonClick()
              }}
            ></CopyContentButton>
          </div>
        </div>
      </Grid.Col>
    </Grid>
  )
}
